<div class="auth-container" [appThemeColor]="colorTheme">

   <div class="left" style="background-image: url({{fondoCentral}});">
        <app-loader *ngIf="loadingImagenes" class="box-free" [big]="true"></app-loader>
        <div *ngIf="!loadingImagenes && imagenCentral" class="box-free central-image" style="
                background-size: cover; 
                border-top-left-radius: 5px; 
                border-bottom-left-radius: 5px;
                background-image: url({{imagenCentral}});
                background-size: 100% 100%;">
        </div>
        <app-loader *ngIf="loadingImagenes" class="logo d-flex justify-content-center" [big]="false" style="position: absolute; left: 95px; bottom: 65px;"></app-loader>
        <img *ngIf="!loadingImagenes && logoWeb" class="logo" src='{{logoWeb}}' 
            style="width: 197px; display: block; margin: 0 auto; margin-bottom: 5px; position: absolute; right: 52.5%; top: 35px;"
        >
        <img *ngIf="!loadingImagenes && !logoWeb" class="logo" src='../../assets/img/logo-1.png' style="width: 197px; display: block; margin: 0 auto; position: absolute; right: 52.5%; top: 35px;">
    </div>

    <!--div class="right">-->
    <div class="right">
        <div class="box-free container-form">
            <!--<form [formGroup]="loginForm" class="login-form" (ngSubmit)="checkCaptcha($event)">
                <app-loader *ngIf="loadingImagenes" class="logo d-flex justify-content-center" [big]="false"></app-loader>
                <img *ngIf="!loadingImagenes && logoWeb" class="logo" src='{{logoWeb}}' 
                    style=" width: 140px; display: block; margin: 0 auto; margin-bottom: 5px;"
                >
                <img *ngIf="!loadingImagenes && !logoWeb" class="logo" src='../../assets/img/noe.svg' style=" width: 140px; display: block; margin: 0 auto;">

                <div class="input-user-container">
                    <app-input
                        type="text" 
                        label="Usuario" 
                        formControlName="user"
                        placeholder="aaaa@aaa.com"
                    ></app-input>
                    <i 
                        class="las la-info-circle cursor-pointer"
                        appTooltip="Ingresar correo electrónico"
                    ></i>
                </div>

                <div class="input-pass-container">
                    <app-input 
                        [(type)]="inputType" 
                        label="Contraseña" 
                        formControlName="password"
                        appInputPassIcon
                    ></app-input>
                    <i class="las la-eye-slash"></i>
                </div>

                <p class="error-message" *ngIf="errorCredenciales">Error de Credenciales</p>
                <p class="error-message" *ngIf="errorReset">La contraseña del usuario debe ser restaurada</p>
                <p class="error-message" *ngIf="errorSubdominio">El usuario no pertenece a este subdominio</p>

                <p class="login-help" (click)="recovery()">¿Olvidé mi contraseña?</p>

                <ngx-invisible-recaptcha #captcha [siteKey]="siteKey" (reset)="reset()" (ready)="ready()" (load)="load()" (success)="success($event)" (expire)="expire()" (error)="error()" [useGlobalDomain]="false" badge="bottomleft" [(ngModel)]="recaptcha" [ngModelOptions]="{ standalone: true }">
                </ngx-invisible-recaptcha>

                <button *ngIf="!loading" type="submit">Ingresar</button>
                <button  class="btn danger" type="button" (click)="onLoginGoogle()">Google</button>
                <button *ngIf="loading" class="disabled loading" type="submit">
                    Ingresando
                </button>

                <app-footer></app-footer>

            </form>-->

            <!--Login Free-->
            <div *ngIf="verLogin && !verRegistrate && !verRegistrateForm && !verCodeForm && !verRecoveryForm" class="one-row-login">
                <form [formGroup]="loginForm" class="login-form" (ngSubmit)="checkCaptcha($event)">
                    <!--<app-loader *ngIf="loadingImagenes" class="logo d-flex justify-content-center" [big]="false"></app-loader>
                    <img *ngIf="!loadingImagenes && logoWeb" class="logo" src='{{logoWeb}}' 
                        style=" width: 140px; display: block; margin: 0 auto; margin-bottom: 5px;"
                    >
                    <img *ngIf="!loadingImagenes && !logoWeb" class="logo" src='../../assets/img/noe.svg' style=" width: 140px; display: block; margin: 0 auto;">-->

                    <img class="logo-resp" src='../../assets/img/logo-1.png'
                    style="width: 152px; display: block; margin-bottom: 30px; margin-left: 10px;">

                    <label class="text-login-bienvenido">¡Bienvenido a NOE!</label>  
                    <!--<label class="text-login">¿Aún no tienes cuenta?</label>                    
                    <label class="text-login-registrate" (click)="verRegistrate=true; verLogin=false; actualizarImagenesPersonalizacion();"><strong class="link-cursor">Regístrate</strong></label>-->
                    <div class="input-user-container">
                        <app-input
                            type="email" 
                            label="Correo" 
                            formControlName="user"
                            placeholder="aaaa@aaa.com"
                            [(ngModel)]="datoUser"
                        ></app-input>
                        <!--<i 
                            class="las la-info-circle cursor-pointer"
                            appTooltip="Ingresar correo electrónico"
                        ></i>-->
                    </div>

                    <div class="input-pass-container">
                        <app-input 
                            [(type)]="inputType" 
                            label="Contraseña" 
                            formControlName="password"
                            appInputPassIcon
                            [(ngModel)]="datoPassword"
                        ></app-input>
                        <i class="las la-eye-slash"></i>
                    </div>

                    <p class="error-message" *ngIf="errorCredenciales">Error de Credenciales</p>
                    <p class="error-message" *ngIf="errorReset">La contraseña del usuario debe ser restaurada</p>
                    <p class="error-message" *ngIf="errorSubdominio">El usuario no pertenece a este subdominio</p>

                    <div class="d-flex check-login">
                        <div class="input-check-container-login">
                            <label class="d-inline label-check">
                                <input type="checkbox" class="rememberCheck" formControlName="remember" (click)="rememberUser()">
                                <span class="d-inline-block"></span>
                            Recordarme
                            </label>
                        </div>
                        <div class="input-check-container-login">
                            <span class="login-help" (click)="verLogin=false; verRecoveryForm=true; actualizarImagenesPersonalizacion();">¿No recuerdas tu contraseña?</span>
                        </div>
                    </div>

                    <ngx-invisible-recaptcha #captcha [siteKey]="siteKey" (reset)="reset()" (ready)="ready()" (load)="load()" (success)="success($event)" (expire)="expire()" (error)="error()" [useGlobalDomain]="false" badge="bottomleft" [(ngModel)]="recaptcha" [ngModelOptions]="{ standalone: true }">
                    </ngx-invisible-recaptcha>

                    <button *ngIf="!loading" type="submit"><strong>Ingresar</strong></button>

                    <button *ngIf="loading" class="disabled loading" type="submit">
                        <strong>Ingresando</strong>
                    </button>

                    <app-footer></app-footer>
                </form>

                <!--<div class="login-form login-default">
                    <div class="content-o">
                        <div class="linea">&nbsp;</div>
                        <div class="leyenda">o</div>
                        <div class="linea">&nbsp;</div>
                    </div>

                    <button class="login-social" type="submit" (click)="onLoginFacebook()">
                        <img class="logo logo-resp1" src='../../assets/img/noe-free/icon-facebook.png' style="height: 20px; margin-right: 5px; margin-bottom: -3.5px;">
                        Ingresa con Facebook
                    </button>
                    <button class="login-social" type="submit" (click)="onLoginGoogle()">
                        <img class="logo logo-resp2" src='../../assets/img/noe-free/icon-google.png' style="width: 20px; margin-right: 5px; margin-bottom: -3.5px;">
                        Ingresa con Google
                    </button>
                    <button class="login-social" type="submit" (click)="onLoginApple()">
                        <img class="logo logo-resp3" src='../../assets/img/noe-free/icon-apple.png' style="width: 18px; margin-right: 5px; margin-bottom: -3.5px;">
                        Ingresa con Apple
                    </button>
                </div>-->
            </div>
            
            <!--Registrate Free-->
            <div *ngIf="verRegistrate && !verRegistrateForm && !verLogin && !verCodeForm && !verRecoveryForm">

                <img class="logo-resp" src='../../assets/img/logo-1.png'
                    style="width: 152px; display: block; margin-bottom: 30px; margin-left: 10px;">

                <div class="login-form login-correo">
                    <label class="text-login-bienvenido">¡Únete a NOE!</label>  
                    <label class="text-login">Firmar documentos nunca fue tan fácil</label>                    
                    <button class="login-social top" type="submit" (click)="verRegistrateForm=true; verRegistrate=false; actualizarImagenesPersonalizacion();">
                        Regístrate con correo
                    </button>
                    
                    <div class="content-o">
                        <div class="linea">&nbsp;</div>
                        <div class="leyenda">o</div>
                        <div class="linea">&nbsp;</div>
                    </div>

                    <button class="login-social" type="submit" (click)="onLoginFacebook()">
                        <img class="logo logo-resp1" src='../../assets/img/noe-free/icon-facebook.png' style="height: 20px; margin-right: 5px; margin-bottom: -3.5px;">
                        Ingresa con Facebook
                    </button>
                    <button class="login-social" type="submit" (click)="onLoginGoogle()">
                        <img class="logo logo-resp2" src='../../assets/img/noe-free/icon-google.png' style="width: 20px; margin-right: 5px; margin-bottom: -3.5px;">
                        Ingresa con Google
                    </button>
                    <button class="login-social" type="submit" (click)="onLoginApple()">
                        <img class="logo logo-resp3" src='../../assets/img/noe-free/icon-apple.png' style="width: 20px; margin-right: 5px; margin-bottom: -3.5px;">
                        Ingresa con Apple
                    </button>
                    <div class="input-check-container-2">
                        <label class="text-login">¿Ya eres parte de NOE?</label>                    
                        <label class="text-login-registrate" (click)="verLogin=true; verRegistrate=false; actualizarImagenesPersonalizacion();"><strong>Inicia sesión</strong></label>
                    </div>
                </div>
            </div>

            <!--Registrate con Correo Free-->
            <div *ngIf="verRegistrateForm && !verRegistrate && !verLogin && !verCodeForm && !verRecoveryForm" class="login-form">
                <form [formGroup]="registrateForm" (ngSubmit)="checkCaptchaUsuario($event)" *ngIf="registrateForm" onkeydown="return event.key != 'Enter';">    
                    <label class="text-registro">Para registrarte necesitamos que completes los siguientes datos:</label>
                    <div class="double-row">
                        <div class="login-correo input-user-container">
                            <app-input
                                type="text" 
                                label="Nombre" 
                                formControlName="name"
                                placeholder=""
                            ></app-input>
                        </div>
                        <div class="login-correo input-user-container">
                            <app-input
                                type="text" 
                                label="Apellido" 
                                formControlName="paternalSurname"
                                placeholder=""
                            ></app-input>
                        </div>
                    </div>

                    <div class="login-correo input-user-container mb-telefono">
                        <label>Número de teléfono</label>
                        <div class="double-row-perfil-select">
                            <app-input type="select" formControlName="nationalType" [selectOptions]="countries" [selectOptionsName]="'optionName'" [selectOptionsKey]="'code'"></app-input>
                            <app-input type="number" formControlName="phoneNumber"></app-input>
                        </div>
                    </div>

                    <div class="login-correo input-user-container">
                        <label>Documento de identificación</label>
                        <div class="double-row-registrate">
                            <div class="input-user-container">
                                <select type="text" [class.error]="registrateForm.controls['identityType'].touched && !theValue" [(ngModel)]="theValue" (change)="getChangeDoc($event.target.value)" formControlName="identityType">
                                    <option disabled selected>Seleccione</option>
                                    <option *ngFor="let o of options" [value]="o.name">
                                        {{o.name}}  
                                    </option>
                                </select>
                                <div class="error-block" *ngIf="registrateForm.controls['identityType'].invalid && registrateForm.controls['identityType'].touched && this.idDocSelect == null">
                                    <p>Este campo es obligatorio</p>
                                </div>
                            </div>

                            <div class="input-user-container">
                                <app-input
                                    type="text" 
                                    formControlName="identityNumber"
                                    placeholder="73214243"
                                    [vmaxlength]="true"
                                ></app-input>

                                <span class="error-block" *ngIf="!dniControl.invalid && dniControl.touched">
                                    <p *ngIf="existeDni">
                                        {{ validacionDni }}
                                    </p>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="login-correo input-user-container">
                        <app-input [class.error]="existeEmail"
                            type="email" 
                            label="Correo" 
                            formControlName="email"
                            placeholder="aaaa@aaa.com"
                        ></app-input>
                    </div>

                    <span class="error-block" *ngIf="emailControl.invalid && emailControl.touched">
                        <p *ngIf="!existeEmail">
                            Algo salio mal escriba de nuevo.
                        </p>
                    </span>

                    <span class="error-block" *ngIf="!emailControl.invalid && emailControl.touched">
                        <p *ngIf="existeEmail">
                            El correo ingresado ya se encuentra registrado.
                        </p>
                    </span>

                    <div class="login-correo input-pass-container">
                        <app-input
                            [(type)]="inputType" 
                            label="Contraseña" 
                            type="password" 
                            formControlName="password"
                            appInputPassIcon
                            (keyup)="validarEspacios($event)"
                        ></app-input>
                        <i class="las la-eye-slash"></i>
                    </div>

                    <p class="error-message" *ngIf="registrateForm.controls.password.errors?.capitalValidator || registrateForm.controls.password.errors?.symbolValidator || registrateForm.controls.password.errors?.numberValidator">
                        La contraseña debe contener mayúsculas, carácter especiales y números.
                    </p>

                    <div class="login-correo input-check-container-1">
                        <label class="d-flex label-check">
                            <input type="checkbox" formControlName="autorizar">
                            <span class="d-inline-block"></span>
                            <span class="text-check">Autorizo recibir comunicaciones promocionales</span>
                        </label>
                    </div>
                    <div class="login-correo input-check-container-2">
                        <label class="d-flex label-check">
                            <input type="checkbox" class="check2" formControlName="declarar" [required]="true" (change)="checkDeclarar($event.target.checked)">
                            <span class="d-inline-block"></span>
                            <span class="text-check-top">Declaro que he leido y acepto los
                                <span class="link-cursor" (click)="abrirModalLecturaTerminos()">
                                    <strong>Términos y condiciones</strong>
                                </span>
                            </span>
                        </label>
                        <div class="error-block" *ngIf="registrateForm.touched">
                            <p *ngIf="!this.registrateForm.get('declarar').value">Este campo es obligatorio</p>
                        </div>
                    </div>

                    <p class="error-message" *ngIf="errorCredenciales">Error de Credenciales</p>
                    <p class="error-message" *ngIf="errorReset">La contraseña del usuario debe ser restaurada</p>
                    <p class="error-message" *ngIf="errorSubdominio">El usuario no pertenece a este subdominio</p>

                    <ngx-invisible-recaptcha #captcha [siteKey]="siteKey" (reset)="reset()" (ready)="ready()" (load)="load()" (success)="success($event)" (expire)="expire()" (error)="error()" [useGlobalDomain]="false" badge="bottomleft" [(ngModel)]="recaptcha" [ngModelOptions]="{ standalone: true }">
                    </ngx-invisible-recaptcha>

                    <button *ngIf="!loadingAccount" [class.disabled]="!loading && !(registrateForm.valid && validarCheck)" type="submit"><strong>Crear tu cuenta</strong></button>
                    <button *ngIf="loadingAccount" class="disabled loading" type="submit">
                        <strong>Crear tu cuenta</strong>
                    </button>

                </form>
                
                <button class="cancelar" type="submit" (click)="verRegistrateForm = false; verRegistrate = true;"><strong>Cancelar</strong></button>
            </div>

            <!--Recuperar Contraseña Free-->
            <form *ngIf="verRecoveryForm && !verCodeForm && !verRegistrateForm && !verRegistrate && !verLogin" [formGroup]="recoveryForm" (submit)="afterRecoverValidation($event)" [hidden]="insertCode">

                <img class="logo-resp" src='../../assets/img/logo-1.png'
                    style="width: 152px; display: block; margin-bottom: 15px; margin-left: 10px;">

                <div class="recover-container">
                    <label class="text-recovery"><strong>¿Haz olvidado tu contraseña?</strong></label>
                    <label class="text-login">Introduce la dirección de correo electrónico asociada a tu cuenta y se te enviará un código de validación para restablecer tu contraseña.</label>
                    <div class="recover-container__actions">
                        <app-input [class.error]="errorNoVerificado || errorNoExiste || (errorTemporal && !rLoading) || maximoDeIntentos"
                            #user 
                            type="text" 
                            label="Correo"
                            placeholder="aaaa@aaa.com"
                            formControlName="user"
                        ></app-input>
        
                        <p class="error-message" *ngIf="errorNoVerificado">
                            No podemos restaurar la contraseña de {{recoveryForm.get('user').value}} porque este usuario no posee correo electrónico o número de teléfono verificados.
                        </p>
                        <p class="error-message" *ngIf="errorNoExiste">
                            El correo ingresado no está registrado en la plataforma
                        </p>
                        <p class="error-message" *ngIf="errorTemporal && !rLoading">
                            No podemos restaurar una contraseña temporal. Se ha reenviado la invitación de bienvenida con su contraseña al correo <b>{{correoUsuario}}</b>.
                        </p>
                        <p class="error-message" *ngIf="maximoDeIntentos">
                            Ha superado el máximo de intentos de recuperación. Por favor espere unos momentos antes de intentar de nuevo.
                        </p>
                        <p class="error-message" *ngIf="errorUsuarioRedSocial">
                            Lo sentimos no podemos restaurar tu acceso mediante tu logueo por red social. Favor de ingresar a la red social por el cual ingresaste.
                        </p>
        
                        <!-- <p class="error-message" *ngIf="errorSubdominio">El usuario no pertenece a este subdominio</p> -->
        
                        <div>
                            <button 
                                *ngIf="!rLoading && !errorTemporal" 
                                class="login-submit btn-enviar-resp d-block w-xs-50 w-100" 
                                type="submit"
                            >Enviar código de validación</button>
        
                            <button 
                                *ngIf="rLoading" 
                                class="login-submit disabled btn-enviar-resp loading d-block w-xs-50 w-100" 
                                type="submit"
                            >
                            Enviando código de validación
                            </button>

                            <button 
                                *ngIf="errorTemporal && !rLoading" 
                                type="submit" 
                                class="login-submit d-block w-xs-50 w-100" 
                                (click)="clearRecovery(); verRecoveryForm=false; verLogin=true; actualizarImagenesPersonalizacion();"
                            >Entendido</button>
                                    
                            <button
                                type="submit" 
                                class="cancelar d-block w-xs-50 w-100" 
                                (click)="clearRecovery(); verRecoveryForm=false; verLogin=true; actualizarImagenesPersonalizacion();"
                            >Cancelar</button>
                        </div>
                    </div>
                </div>
        
            </form>
        
            <form *ngIf="verCodeForm && !verRecoveryForm && !verRegistrateForm && !verRegistrate && !verLogin" [formGroup]="codeForm" (submit)="submitCode($event)" [hidden]="!insertCode">
                <img class="logo-resp" src='../../assets/img/logo-1.png'
                    style="width: 152px; display: block; margin-bottom: 15px; margin-left: 10px;">

                <label class="titulo-resp text-recovery"><strong>¿Haz olvidado tu contraseña?</strong></label>
                <label class="titulo-resp text-login">Introduce la dirección de correo electrónico asociada a tu cuenta y se te enviará un código de validación para restablecer tu contraseña.</label>
                    
                <label class="titulo-default text-recovery"><strong>Restablecer contraseña</strong></label>
                <!--<em>Se te ha enviado un correo con un “código de verificación” para que puedas generar una nueva contraseña.</em>-->
        
                <!--<app-input type="text" label="Usuario" formControlName="user" [required]="true"></app-input>-->
        
                <app-input type="text" label="Escribir código de validación:" formControlName="code" [required]="true"></app-input>
        
                <p class="error-message" *ngIf="errorCode">Código de validación incorrecto</p>
        
                <div class="input-pass-container">
                    <app-input [(type)]="inputTypeNew" type="password" label="Escribir nueva contraseña" formControlName="password" appInputPassIcon></app-input><i class="las la-eye-slash"></i>
                </div>
                
                <p class="error-message" *ngIf="codeForm.controls.password.errors?.capitalValidator || codeForm.controls.password.errors?.symbolValidator || codeForm.controls.password.errors?.numberValidator">
                    La contraseña debe contener mayúsculas, carácter especiales y números.
                </p>

                <div class="input-pass-container">
                    <app-input [(type)]="inputType" type="password" label="Repetir contraseña" formControlName="confirm" appInputPassIcon></app-input><i class="las la-eye-slash"></i>
                </div>
                
                <p class="error-message" *ngIf="codeForm.controls.password.errors?.capitalValidator || codeForm.controls.password.errors?.symbolValidator || codeForm.controls.password.errors?.numberValidator">
                    La contraseña debe contener mayúsculas, carácter especiales y números.
                </p>

                <p class="error-message" *ngIf="codeForm.errors?.mismatch">Las contraseñas deben coincidir</p>

                <ngx-invisible-recaptcha #captcha [siteKey]="siteKey" (reset)="reset()" (ready)="ready()" (load)="load()" (success)="success($event)" (expire)="expire()" (error)="error()" [useGlobalDomain]="false" badge="bottomleft" [(ngModel)]="recaptcha" [ngModelOptions]="{ standalone: true }">
                </ngx-invisible-recaptcha>
                <!--<app-password-validators [form]="codeForm" [validators]="this.validators.validators">
                </app-password-validators>-->
        
                <div>
                    <button *ngIf="!cLoading" [disabled]="codeForm.invalid" class="login-submit d-block w-100" type="submit">Restablecer contraseña</button>
        
                    <button *ngIf="cLoading" class="login-submit disabled loading d-block w-100" type="submit">
                        Restableciendo contraseña
                    </button>

                    <button
                        type="submit" 
                        class="cancelar d-block w-100" 
                        (click)="clearRecovery(); verCodeForm=false; verLogin=true; actualizarImagenesPersonalizacion();"
                    >Cancelar</button>
                </div>
        
            </form>

        </div>
    </div>

    <!-- <div class="form-container">

        <div class="display">
            <img src="../../assets/img/bg.jpg">
        </div>
        
        <form [formGroup]="loginForm" class="login-form" (submit)="login($event)">

            <img class="logo" src="../../assets/img/noe.svg" alt="NOE">

            <app-input
            type="text"
            label="Usuario"
            formControlName="user"></app-input>

            <app-input
            type="password"
            label="Contraseña"
            formControlName="password"></app-input>

            <p class="error-message" *ngIf="errorCredenciales">Error de Credenciales</p>
            <p class="error-message" *ngIf="errorReset">La contraseña del usuario debe ser restaurada</p>

            <p class="login-help" (click)="recovery()">He olvidado mi contraseña</p>

            <button 
            *ngIf="!loading"
            class="login-submit" 
            type="submit">Ingresar</button>

            <button 
            *ngIf="loading"
            class="login-submit disabled loading" 
            type="submit">
                Ingresando
            </button>

        </form>

    </div> -->
</div>

<app-loader 
    *ngIf="loading" 
    class="login-loading" 
    [big]="true"
    [no-bg]="true"
></app-loader>

<app-modal-lectura #modalLecturaTerminos class="modal-lectura" titleModal="Términos y Condiciones" [scroller]="true">
    <app-terminos-y-condiciones></app-terminos-y-condiciones>
</app-modal-lectura>

<!-- Modal Cambio Contraseña Completado -->
<app-modal #modalCompletado class="modalCompletado" [hide-footer]="true">

    <img class="logo" src='../../assets/img/noe-free/party.png' style="height: 35px; display:block; margin: 0 auto;">

    <label class="text-center text-modalRecovery"><strong>Cambio de contraseña exitoso</strong></label>

    <div class="text-center">
        <button class="login-submit" type="submit" (click)="closeModalCompletado()">Completado</button>
    </div>
</app-modal>

<!-- Modal Cambiar Contraseña Temporal -->
<app-modal #passModal titleModal="Crear nueva contraseña" class="modalNuevaContrasena" [hide-footer]="true">

    <form [formGroup]="passForm" (submit)="completarPass($event)">

        <div class="input-passModal-container">
            <app-input [(type)]="inputTypePassNew" type="password" label="Nueva Contraseña" formControlName="password" [required]="true" appInputPassIcon></app-input>
            <i class="las la-eye-slash"></i>
        </div>

        <div class="input-passModal-container">
            <app-input [(type)]="inputTypePass" type="password" label="Confirmar Contraseña" formControlName="confirm" [required]="true" appInputPassIcon></app-input>
            <i class="las la-eye-slash"></i>
        </div>

        <p class="error-message" *ngIf="passForm.errors?.mismatch">Las contraseñas deben coincidir</p>

        <app-password-validators [form]="passForm" [titlePass]="true" [validators]="this.validators.validators">
        </app-password-validators>

        <div class="form-footer">
            <button *ngIf="!pLoading" class="btn-ingresar d-block w-100" type="submit">Ingresar</button>

            <button *ngIf="pLoading" class="btn-ingresar disabled loading d-block w-100" type="submit">
                Ingresando
            </button>
        </div>

    </form>

</app-modal>

<!-- Modal Cambio Contraseña Correo Completado -->
<app-modal #modalCompletadoCorreo class="modalCompletado" [hide-footer]="true">

    <img class="logo" src='../../assets/img/noe-free/party.png' style="height: 35px; display:block; margin: 0 auto;">

    <label class="text-center text-modalRecovery"><strong>Cambio de contraseña exitoso</strong></label>

    <div class="text-center">
        <button class="login-submit" type="submit" (click)="closeModalCompletadoCorreo()">Completado</button>
    </div>
</app-modal>

<!-- Modal Cambiar Contraseña Correo -->
<app-modal #passModalCorreo titleModal="Crear nueva contraseña" class="modalNuevaContrasena" [hide-footer]="true">

    <form [formGroup]="passCorreoForm" (submit)="submitCodeCorreo($event)">

        <div class="input-passModal-container">
            <app-input type="text" label="Código de verificación" formControlName="code" [required]="true"></app-input>
            <p class="error-message" *ngIf="errorCode">Código de verificación incorrecto</p>
        </div>
        
        <div class="input-passModal-container">
            <app-input [(type)]="inputTypePassNew" type="password" label="Nueva Contraseña" formControlName="password" [required]="true" appInputPassIcon></app-input>
            <i class="las la-eye-slash"></i>
        </div>

        <div class="input-passModal-container">
            <app-input [(type)]="inputTypePass" type="password" label="Confirmar Contraseña" formControlName="confirm" [required]="true" appInputPassIcon></app-input>
            <i class="las la-eye-slash"></i>
        </div>

        <p class="error-message" *ngIf="passCorreoForm.errors?.mismatch">Las contraseñas deben coincidir</p>

        <app-password-validators [form]="passCorreoForm" [titlePass]="true" [validators]="this.validators.validators">
        </app-password-validators>

        <div class="form-footer">
            <button *ngIf="!pLoading" class="btn-ingresar d-block w-100" type="submit">Ingresar</button>

            <button *ngIf="pLoading" class="btn-ingresar disabled loading d-block w-100" type="submit">
                Ingresando
            </button>
        </div>

    </form>

</app-modal>

<!-- Modal Recuperar -->
<app-modal #recoveryModal (closed)="clearRecovery()" titleModal="Recuperar Contraseña" [hide-footer]="true">

    <form [formGroup]="recoveryForm" (submit)="afterRecoverValidation($event)" [hidden]="insertCode">

        <div class="recover-container">
            <img 
                class="recover-container__img"
                src="/assets/img/recover-password.png" 
                width="160" alt=""
            >
            
            <div class="recover-container__actions">
                <app-input
                    #user 
                    type="text" 
                    label="Usuario"
                    placeholder="aaaa@aaa.com"
                    formControlName="user"
                ></app-input>

                <p class="error-message" *ngIf="errorNoVerificado">
                    No podemos restaurar la contraseña de {{recoveryForm.get('user').value}} porque este usuario no posee correo electrónico o número de teléfono verificados.
                </p>
                <p class="error-message" *ngIf="errorNoExiste">
                    Este usuario no existe
                </p>
                <p class="error-message" *ngIf="errorTemporal && !rLoading">
                    No podemos restaurar una contraseña temporal. Se ha reenviado la invitación de bienvenida con su contraseña al correo <b>{{correoUsuario}}</b>.
                </p>
                <p class="error-message" *ngIf="maximoDeIntentos">
                    Ha superado el máximo de intentos de recuperación. Por favor espere unos momentos antes de intentar de nuevo.
                </p>
                <p class="error-message" *ngIf="errorUsuarioRedSocial">
                    Lo sentimos no podemos restaurar tu acceso mediante tu logueo por red social. Favor de ingresar a la red social por el cual ingresaste.
                </p>

                <!-- <p class="error-message" *ngIf="errorSubdominio">El usuario no pertenece a este subdominio</p> -->

                <div class="form-footer">
                    <button 
                        *ngIf="!rLoading && !errorTemporal" 
                        class="login-submit d-block w-xs-50 w-100" 
                        type="submit"
                    >Continuar</button>

                    <button 
                        *ngIf="rLoading" 
                        class="login-submit disabled loading d-block w-xs-50 w-100" 
                        type="submit"
                    >
                        Enviando
                    </button>

                    <button 
                        *ngIf="errorTemporal && !rLoading" 
                        type="submit" 
                        class="login-submit d-block w-xs-50 w-100" 
                        (click)="clearRecovery(); recoveryModal.close()"
                    >Entendido</button>
                </div>
            </div>
        </div>

    </form>

    <form [formGroup]="codeForm" (submit)="submitCode($event)" [hidden]="!insertCode">

        <em>Se te ha enviado un correo con un “código de verificación” para que puedas generar una nueva contraseña.</em>

        <app-input type="text" label="Usuario" formControlName="user" [required]="true"></app-input>

        <app-input type="text" label="Código de verificación" formControlName="code" [required]="true"></app-input>

        <p class="error-message" *ngIf="errorCode">Código de verificación incorrecto</p>

        <app-input type="password" label="Nueva Contraseña" formControlName="password" [required]="true"></app-input>

        <app-input type="password" label="Confirmar Contraseña" formControlName="confirm" [required]="true"></app-input>

        <app-password-validators [form]="codeForm" [validators]="this.validators.validators">
        </app-password-validators>

        <div class="form-footer">
            <button *ngIf="!cLoading" class="login-submit d-block w-100" type="submit">Confirmar</button>

            <button *ngIf="cLoading" class="login-submit disabled loading d-block w-100" type="submit">
                Enviando
            </button>
        </div>

    </form>

</app-modal>

<!-- Modal Sesión Terminada -->
<app-modal #modalSesion>

    <div class="display info w-100 mt-1">
        <span class="d-inline-block"><i class="las la-clock"></i></span>
        <p class=" text-center mt-2">{{sessionMsg}}</p>
    </div>

    <div class="text-center mt-4">
        <button class="btn success" (click)="modalSesion.close()">Entendido</button>
    </div>
</app-modal>

<app-modal #modalUsuarioInactivo class="modalGuardarFree" titleModal="Usuario Inactivo" [hide-footer]="true">
    <p>Lo sentimos, la plataforma se encuentra inhabilitada por falta de pago. Regulariza tu pago o puedes contactarnos al correo: 
        <a href="mailto:ventas@noe.pe" target="_blank" style="color: #1a6994; text-decoration: underline;">ventas@noe.pe</a>
    </p>
    <div class="d-flex justify-content-center" style="margin-top: 20px;">
        <button class="btn success" (click)="modalUsuarioInactivo.close()">Entendido</button>
    </div>
</app-modal>


<app-notifications></app-notifications>